/*
 * @Author: zhangwenbangde@163.com
 * @Date: 2019-04-18 15:56:56
 * */
const routerMode = 'history'; // vue-router的路由模式  history or hash
const staticPath = '/promotion-pc'; // 静态资源路径
const sourceCode = 'GSNH'; // 机构标识    GSNH
const entryPath = '/promotion-pc'; // 入口url路径
const requestCode = '020001'; //接口编码

export {
  routerMode,
  staticPath,
  sourceCode,
  entryPath,
  requestCode
};